module.exports = __webpack_public_path__ + "media/images/common/new_entry_btn2_ov-b785c9b3d28f0ebce149890d23962c2c.png";